import { render, staticRenderFns } from "./BeAlert.vue?vue&type=template&id=680bff9a&scoped=true"
import script from "./BeAlert.vue?vue&type=script&lang=js"
export * from "./BeAlert.vue?vue&type=script&lang=js"
import style0 from "./BeAlert.vue?vue&type=style&index=0&id=680bff9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680bff9a",
  null
  
)

export default component.exports